import React from 'react'

import { useSurveyForSettingsQueryData } from './useSurveyForSettingsQueryData'

export const useSurveyForSettingsQueryBrandGroups = () => {
  const survey = useSurveyForSettingsQueryData()

  return React.useMemo(() => survey?.brandGroups ?? [], [survey?.brandGroups])
}
